<template>
  <div v-if="!$app.isApp && isVisible" class="w-full border-b flex items-center p-3 pl-0 justify-between bg-white dark:bg-gray-900">
    <div class="flex items-center">
      <o-icon icon="x" class="p-3" :size="10" @click="handleHideBanner" />

      <img src="~/assets/images/logo/app-icon.png" class="h-12">

      <div class="ml-4">
        <p class="text-sm text-gray-800 dark:text-gray-100 leading-none font-medium mb-1">
          {{ $t('components.layout.banner.ovatuNext') }}
        </p>
        <p class="text-xs text-gray-500 dark:text-gray-400 leading-none">
          {{ $t('components.layout.banner.installApp') }}
        </p>
      </div>
    </div>

    <div>
      <a v-if="isApple" href="https://itunes.apple.com/au/app/ovatu-next/id1589890786" target="_blank" class="px-3 py-2 bg-blue-600 text-white font-medium uppercase text-sm block rounded-full leading-none tracking-wider">
        {{ $t('components.layout.banner.install') }}
      </a>
      <a v-if="isAndroid" href="https://play.google.com/store/apps/details?id=com.ovatu.next" target="_blank" class="px-3 py-2 bg-blue-600 text-white font-medium uppercase text-sm block rounded-full leading-none tracking-wider">
        {{ $t('components.layout.banner.install') }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { UAParser } from 'ua-parser-js'

const { $app, $mobile } = useNuxtApp()

const appbannerHidden = useCookie('appbanner_hidden', { maxAge: 60 * 24 * 60 * 60 })
const device = ref<any>(null)
const ua = ref<any>(null)

const isAndroid = computed(() => device.value?.android?.phone || device.value?.android?.tablet)
const isApple = computed(() => device.value?.apple?.phone || device.value?.apple?.tablet)
const isSafari = computed(() => ua.value?.browser?.name === 'Safari' || ua.value?.browser?.name === 'Mobile Safari')
const isVisible = computed(() => !appbannerHidden.value && (isAndroid.value || (isApple.value && !isSafari.value)))

const handleHideBanner = () => {
  appbannerHidden.value = 'true'
}

onMounted(() => {
  device.value = ($mobile as any).isMobile()
  ua.value = UAParser()
})
</script>
